// // src/components/SignaturePad.jsx
// import React, { useRef, useState, useEffect } from 'react';

// // Helper to convert white/near-white pixels to transparent in uploaded images
// const makeImageTransparent = (dataUrl) => {
//   return new Promise((resolve) => {
//     const img = new Image();
//     img.onload = () => {
//       const canvas = document.createElement('canvas');
//       canvas.width = img.width;
//       canvas.height = img.height;
//       const ctx = canvas.getContext('2d');
//       ctx.drawImage(img, 0, 0);
//       try {
//         const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
//         const data = imgData.data;
//         for (let i = 0; i < data.length; i += 4) {
//           const r = data[i];
//           const g = data[i + 1];
//           const b = data[i + 2];
//           // If pixel is white or near white (threshold 230 to keep darker lines)
//           if (r > 230 && g > 230 && b > 230) {
//             data[i + 3] = 0; // Transparent
//           }
//         }
//         ctx.putImageData(imgData, 0, 0);
//         resolve(canvas.toDataURL('image/png'));
//       } catch (e) {
//         resolve(dataUrl);
//       }
//     };
//     img.onerror = () => resolve(dataUrl);
//     img.src = dataUrl;
//   });
// };

// const SignaturePad = ({ onSave, onChange, initialType = 'DRAW' }) => {
//   const canvasRef = useRef(null);
//   const [sigType, setSigType] = useState(initialType); // DRAW, TYPE, UPLOAD
//   const [typedName, setTypedName] = useState('');
//   const [isDrawing, setIsDrawing] = useState(false);
//   const [uploadedSig, setUploadedSig] = useState(null);

//   const clearCanvas = React.useCallback((notify = true) => {
//     if (!canvasRef.current) return;
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext('2d');
    
//     const style = getComputedStyle(document.documentElement);
//     const textPri = style.getPropertyValue('--text-primary').trim() || '#0f172a';

//     // Clear canvas transparently
//     ctx.clearRect(0, 0, canvas.width, canvas.height);
    
//     // Reset brush options
//     ctx.strokeStyle = textPri;
//     ctx.lineWidth = 2.5;

//     if (notify && onChange) {
//       onChange('', 'DRAW');
//     }
//   }, [onChange]);

//   // Drawing Canvas setup
//   useEffect(() => {
//     if (sigType === 'DRAW' && canvasRef.current) {
//       const canvas = canvasRef.current;
//       const ctx = canvas.getContext('2d');
//       const style = getComputedStyle(document.documentElement);
//       const textPri = style.getPropertyValue('--text-primary').trim() || '#0f172a';
//       ctx.strokeStyle = textPri;
//       ctx.lineWidth = 2.5;
//       ctx.lineCap = 'round';
//       ctx.lineJoin = 'round';
//       clearCanvas(false);
//     }
//   }, [sigType, clearCanvas]);

//   const startDrawing = (e) => {
//     if (!canvasRef.current) return;
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext('2d');
//     const style = getComputedStyle(document.documentElement);
//     const textPri = style.getPropertyValue('--text-primary').trim() || '#0f172a';
//     ctx.strokeStyle = textPri;
//     ctx.lineWidth = 2.5;
//     ctx.lineCap = 'round';
//     ctx.lineJoin = 'round';
    
//     const rect = canvas.getBoundingClientRect();
//     const x = (e.clientX || e.touches[0].clientX) - rect.left;
//     const y = (e.clientY || e.touches[0].clientY) - rect.top;
    
//     ctx.beginPath();
//     ctx.moveTo(x, y);
//     setIsDrawing(true);
//   };

//   const draw = (e) => {
//     if (!isDrawing || !canvasRef.current) return;
//     e.preventDefault();
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext('2d');
//     const rect = canvas.getBoundingClientRect();
//     const x = (e.clientX || (e.touches && e.touches[0].clientX)) - rect.left;
//     const y = (e.clientY || (e.touches && e.touches[0].clientY)) - rect.top;

//     ctx.lineTo(x, y);
//     ctx.stroke();
//   };

//   const stopDrawing = () => {
//     setIsDrawing(false);
//     if (canvasRef.current && onChange) {
//       const dataUrl = canvasRef.current.toDataURL('image/png');
//       onChange(dataUrl, 'DRAW');
//     }
//   };

//   const handleFileUpload = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = async (event) => {
//         const rawDataUrl = event.target.result;
//         // Make the uploaded image transparent if possible
//         const transparentDataUrl = await makeImageTransparent(rawDataUrl);
//         setUploadedSig(transparentDataUrl);
//         if (onChange) {
//           onChange(transparentDataUrl, 'UPLOAD');
//         }
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleSubmit = () => {
//     if (sigType === 'DRAW') {
//       if (canvasRef.current) {
//         const dataUrl = canvasRef.current.toDataURL('image/png');
//         onSave(dataUrl, 'DRAW');
//       }
//     } else if (sigType === 'TYPE') {
//       if (!typedName.trim()) {
//         alert('Please type a name to sign.');
//         return;
//       }
//       onSave(typedName, 'TYPE');
//     } else if (sigType === 'UPLOAD') {
//       if (!uploadedSig) {
//         alert('Please upload a signature image first.');
//         return;
//       }
//       onSave(uploadedSig, 'UPLOAD');
//     }
//   };

//   return (
//     <div className="card" style={{ maxWidth: '450px', margin: '0 auto' }}>
//       <div className="card-title">
//         <span>Apply Electronic Signature</span>
//       </div>
      
//       <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem' }}>
//         <button 
//           type="button"
//           className={`btn ${sigType === 'DRAW' ? 'btn-primary' : 'btn-secondary'}`}
//           onClick={() => setSigType('DRAW')}
//           style={{ flex: 1, fontSize: '0.8rem', padding: '0.5rem' }}
//         >
//           Draw
//         </button>
//         <button 
//           type="button"
//           className={`btn ${sigType === 'TYPE' ? 'btn-primary' : 'btn-secondary'}`}
//           onClick={() => setSigType('TYPE')}
//           style={{ flex: 1, fontSize: '0.8rem', padding: '0.5rem' }}
//         >
//           Type
//         </button>
//         <button 
//           type="button"
//           className={`btn ${sigType === 'UPLOAD' ? 'btn-primary' : 'btn-secondary'}`}
//           onClick={() => setSigType('UPLOAD')}
//           style={{ flex: 1, fontSize: '0.8rem', padding: '0.5rem' }}
//         >
//           Upload
//         </button>
//       </div>

//       <div style={{ marginBottom: '1.25rem' }}>
//         {sigType === 'DRAW' && (
//           <div>
//             <div style={{ position: 'relative', width: '100%', maxWidth: '400px' }}>
//               <canvas
//                 ref={canvasRef}
//                 width={400}
//                 height={150}
//                 style={{
//                   border: '1px solid var(--border-color)',
//                   borderRadius: 'var(--border-radius-sm)',
//                   backgroundColor: 'var(--bg-secondary)',
//                   cursor: 'crosshair',
//                   touchAction: 'none',
//                   width: '100%',
//                   maxWidth: '400px',
//                   display: 'block'
//                 }}
//                 onMouseDown={startDrawing}
//                 onMouseMove={draw}
//                 onMouseUp={stopDrawing}
//                 onMouseLeave={stopDrawing}
//                 onTouchStart={startDrawing}
//                 onTouchMove={draw}
//                 onTouchEnd={stopDrawing}
//               />
//               <div 
//                 style={{
//                   position: 'absolute',
//                   bottom: '40px',
//                   left: '20px',
//                   right: '20px',
//                   height: '1px',
//                   backgroundColor: 'var(--border-color)',
//                   pointerEvents: 'none'
//                 }} 
//               />
//             </div>
//             <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '0.5rem' }}>
//               <button type="button" className="btn btn-secondary" style={{ padding: '0.25rem 0.75rem', fontSize: '0.75rem' }} onClick={() => clearCanvas(true)}>
//                 Clear Board
//               </button>
//             </div>
//           </div>
//         )}

//         {sigType === 'TYPE' && (
//           <div>
//             <input
//               type="text"
//               className="form-control"
//               placeholder="Type your full legal name"
//               value={typedName}
//               onChange={(e) => {
//                 setTypedName(e.target.value);
//                 if (onChange) onChange(e.target.value, 'TYPE');
//               }}
//               style={{ marginBottom: '1rem' }}
//             />
//             {typedName && (
//               <div 
//                 style={{
//                   border: '1px solid var(--border-color)',
//                   borderRadius: 'var(--border-radius-sm)',
//                   padding: '1.5rem',
//                   backgroundColor: 'var(--bg-tertiary)',
//                   textAlign: 'center',
//                   fontSize: '2rem',
//                   fontFamily: '"Outfit", cursive, sans-serif',
//                   fontStyle: 'italic',
//                   color: 'var(--primary)',
//                   letterSpacing: '2px',
//                   userSelect: 'none'
//                 }}
//               >
//                 {typedName}
//               </div>
//             )}
//           </div>
//         )}

//         {sigType === 'UPLOAD' && (
//           <div>
//             <input
//               type="file"
//               accept="image/*"
//               className="form-control"
//               onChange={handleFileUpload}
//               style={{ marginBottom: '1rem' }}
//             />
//             {uploadedSig && (
//               <div style={{ textAlign: 'center', border: '1px solid var(--border-color)', padding: '0.5rem', borderRadius: 'var(--border-radius-sm)' }}>
//                 <img src={uploadedSig} alt="Uploaded signature" style={{ maxHeight: '100px', maxWidth: '100%' }} />
//               </div>
//             )}
//           </div>
//         )}
//       </div>

//       <p style={{ fontSize: '0.75rem', color: 'var(--text-tertiary)', marginBottom: '1rem', textAlign: 'center' }}>
//         By clicking "Apply", I agree that this is a legally binding equivalent of my handwritten signature.
//       </p>

//       <button type="button" className="btn btn-primary" style={{ width: '100%' }} onClick={handleSubmit}>
//         Apply Signature
//       </button>
//     </div>
//   );
// };

// export default SignaturePad;

































// // src/components/SignaturePad.jsx
// import React, { useRef, useState, useEffect } from 'react';

// // Helper to convert white/near-white pixels to transparent in uploaded images
// const makeImageTransparent = (dataUrl) => {
//   return new Promise((resolve) => {
//     const img = new Image();
//     img.onload = () => {
//       const canvas = document.createElement('canvas');
//       canvas.width = img.width;
//       canvas.height = img.height;
//       const ctx = canvas.getContext('2d');
//       ctx.drawImage(img, 0, 0);
//       try {
//         const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
//         const data = imgData.data;
//         for (let i = 0; i < data.length; i += 4) {
//           const r = data[i];
//           const g = data[i + 1];
//           const b = data[i + 2];
//           // If pixel is white or near white (threshold 230 to keep darker lines)
//           if (r > 230 && g > 230 && b > 230) {
//             data[i + 3] = 0; // Transparent
//           }
//         }
//         ctx.putImageData(imgData, 0, 0);
//         resolve(canvas.toDataURL('image/png'));
//       } catch (e) {
//         resolve(dataUrl);
//       }
//     };
//     img.onerror = () => resolve(dataUrl);
//     img.src = dataUrl;
//   });
// };

// const SignaturePad = ({ onSave, onChange, initialType = 'DRAW' }) => {
//   const canvasRef = useRef(null);
//   const [sigType, setSigType] = useState(initialType); // DRAW, TYPE, UPLOAD
//   const [typedName, setTypedName] = useState('');
//   const [isDrawing, setIsDrawing] = useState(false);
//   const [uploadedSig, setUploadedSig] = useState(null);

//   const clearCanvas = React.useCallback((notify = true) => {
//     if (!canvasRef.current) return;
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext('2d');
    
//     const style = getComputedStyle(document.documentElement);
//     const textPri = style.getPropertyValue('--text-primary').trim() || '#0f172a';

//     // Clear canvas transparently
//     ctx.clearRect(0, 0, canvas.width, canvas.height);
    
//     // Reset brush options
//     ctx.strokeStyle = textPri;
//     ctx.lineWidth = 2.5;

//     if (notify && onChange) {
//       onChange('', 'DRAW');
//     }
//   }, [onChange]);

//   // Drawing Canvas setup
//   useEffect(() => {
//     if (sigType === 'DRAW' && canvasRef.current) {
//       const canvas = canvasRef.current;
//       const ctx = canvas.getContext('2d');
//       const style = getComputedStyle(document.documentElement);
//       const textPri = style.getPropertyValue('--text-primary').trim() || '#0f172a';
//       ctx.strokeStyle = textPri;
//       ctx.lineWidth = 2.5;
//       ctx.lineCap = 'round';
//       ctx.lineJoin = 'round';
//       clearCanvas(false);
//     }
//   }, [sigType, clearCanvas]);

//   const startDrawing = (e) => {
//     if (!canvasRef.current) return;
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext('2d');
//     const style = getComputedStyle(document.documentElement);
//     const textPri = style.getPropertyValue('--text-primary').trim() || '#0f172a';
//     ctx.strokeStyle = textPri;
//     ctx.lineWidth = 2.5;
//     ctx.lineCap = 'round';
//     ctx.lineJoin = 'round';
    
//     const rect = canvas.getBoundingClientRect();
//     const x = (e.clientX || e.touches[0].clientX) - rect.left;
//     const y = (e.clientY || e.touches[0].clientY) - rect.top;
    
//     ctx.beginPath();
//     ctx.moveTo(x, y);
//     setIsDrawing(true);
//   };

//   const draw = (e) => {
//     if (!isDrawing || !canvasRef.current) return;
//     e.preventDefault();
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext('2d');
//     const rect = canvas.getBoundingClientRect();
//     const x = (e.clientX || (e.touches && e.touches[0].clientX)) - rect.left;
//     const y = (e.clientY || (e.touches && e.touches[0].clientY)) - rect.top;

//     ctx.lineTo(x, y);
//     ctx.stroke();
//   };

//   const stopDrawing = () => {
//     setIsDrawing(false);
//     if (canvasRef.current && onChange) {
//       const dataUrl = canvasRef.current.toDataURL('image/png');
//       onChange(dataUrl, 'DRAW');
//     }
//   };

//   const handleFileUpload = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = async (event) => {
//         const rawDataUrl = event.target.result;
//         // Make the uploaded image transparent if possible
//         const transparentDataUrl = await makeImageTransparent(rawDataUrl);
//         setUploadedSig(transparentDataUrl);
//         if (onChange) {
//           onChange(transparentDataUrl, 'UPLOAD');
//         }
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleSubmit = () => {
//     if (sigType === 'DRAW') {
//       if (canvasRef.current) {
//         const dataUrl = canvasRef.current.toDataURL('image/png');
//         onSave(dataUrl, 'DRAW');
//       }
//     } else if (sigType === 'TYPE') {
//       if (!typedName.trim()) {
//         alert('Please type a name to sign.');
//         return;
//       }
//       onSave(typedName, 'TYPE');
//     } else if (sigType === 'UPLOAD') {
//       if (!uploadedSig) {
//         alert('Please upload a signature image first.');
//         return;
//       }
//       onSave(uploadedSig, 'UPLOAD');
//     }
//   };

//   return (
//     <div className="card" style={{ maxWidth: '450px', margin: '0 auto' }}>
//       <div className="card-title">
//         <span>Apply Electronic Signature</span>
//       </div>
      
//       <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem' }}>
//         <button 
//           type="button"
//           className={`btn ${sigType === 'DRAW' ? 'btn-primary' : 'btn-secondary'}`}
//           onClick={() => setSigType('DRAW')}
//           style={{ flex: 1, fontSize: '0.8rem', padding: '0.5rem' }}
//         >
//           Draw
//         </button>
//         <button 
//           type="button"
//           className={`btn ${sigType === 'TYPE' ? 'btn-primary' : 'btn-secondary'}`}
//           onClick={() => setSigType('TYPE')}
//           style={{ flex: 1, fontSize: '0.8rem', padding: '0.5rem' }}
//         >
//           Type
//         </button>
//         <button 
//           type="button"
//           className={`btn ${sigType === 'UPLOAD' ? 'btn-primary' : 'btn-secondary'}`}
//           onClick={() => setSigType('UPLOAD')}
//           style={{ flex: 1, fontSize: '0.8rem', padding: '0.5rem' }}
//         >
//           Upload
//         </button>
//       </div>

//       <div style={{ marginBottom: '1.25rem' }}>
//         {sigType === 'DRAW' && (
//           <div>
//             <div style={{ position: 'relative', width: '100%', maxWidth: '400px' }}>
//               <canvas
//                 ref={canvasRef}
//                 width={400}
//                 height={150}
//                 style={{
//                   border: '1px solid var(--border-color)',
//                   borderRadius: 'var(--border-radius-sm)',
//                   backgroundColor: 'var(--bg-secondary)',
//                   cursor: 'crosshair',
//                   touchAction: 'none',
//                   width: '100%',
//                   maxWidth: '400px',
//                   display: 'block'
//                 }}
//                 onMouseDown={startDrawing}
//                 onMouseMove={draw}
//                 onMouseUp={stopDrawing}
//                 onMouseLeave={stopDrawing}
//                 onTouchStart={startDrawing}
//                 onTouchMove={draw}
//                 onTouchEnd={stopDrawing}
//               />
//               <div 
//                 style={{
//                   position: 'absolute',
//                   bottom: '40px',
//                   left: '20px',
//                   right: '20px',
//                   height: '1px',
//                   backgroundColor: 'var(--border-color)',
//                   pointerEvents: 'none'
//                 }} 
//               />
//             </div>
//             <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '0.5rem' }}>
//               <button type="button" className="btn btn-secondary" style={{ padding: '0.25rem 0.75rem', fontSize: '0.75rem' }} onClick={() => clearCanvas(true)}>
//                 Clear Board
//               </button>
//             </div>
//           </div>
//         )}

//         {sigType === 'TYPE' && (
//           <div>
//             <input
//               type="text"
//               className="form-control"
//               placeholder="Type your full legal name"
//               value={typedName}
//               onChange={(e) => {
//                 setTypedName(e.target.value);
//                 if (onChange) onChange(e.target.value, 'TYPE');
//               }}
//               style={{ marginBottom: '1rem' }}
//             />
//             {typedName && (
//               <div 
//                 style={{
//                   border: '1px solid var(--border-color)',
//                   borderRadius: 'var(--border-radius-sm)',
//                   padding: '1.25rem 0.75rem',
//                   backgroundColor: 'var(--bg-tertiary)',
//                   textAlign: 'center',
//                   fontSize: typedName.length > 25 ? '1.25rem' : (typedName.length > 15 ? '1.5rem' : '2rem'),
//                   fontFamily: '"Outfit", cursive, sans-serif',
//                   fontStyle: 'italic',
//                   color: 'var(--primary)',
//                   letterSpacing: '1px',
//                   userSelect: 'none',
//                   wordBreak: 'break-word',
//                   overflowWrap: 'break-word'
//                 }}
//               >
//                 {typedName}
//               </div>
//             )}
//           </div>
//         )}

//         {sigType === 'UPLOAD' && (
//           <div>
//             <input
//               type="file"
//               accept="image/*"
//               className="form-control"
//               onChange={handleFileUpload}
//               style={{ marginBottom: '1rem' }}
//             />
//             {uploadedSig && (
//               <div style={{ textAlign: 'center', border: '1px solid var(--border-color)', padding: '0.5rem', borderRadius: 'var(--border-radius-sm)' }}>
//                 <img src={uploadedSig} alt="Uploaded signature" style={{ maxHeight: '100px', maxWidth: '100%' }} />
//               </div>
//             )}
//           </div>
//         )}
//       </div>

//       <p style={{ fontSize: '0.75rem', color: 'var(--text-tertiary)', marginBottom: '1rem', textAlign: 'center' }}>
//         By clicking "Apply", I agree that this is a legally binding equivalent of my handwritten signature.
//       </p>

//       <button type="button" className="btn btn-primary" style={{ width: '100%' }} onClick={handleSubmit}>
//         Apply Signature
//       </button>
//     </div>
//   );
// };

// export default SignaturePad;

























// // src/components/SignaturePad.jsx
// import React, { useRef, useState, useEffect } from 'react';

// // Helper to convert white/near-white pixels to transparent & scale uploaded images down
// const makeImageTransparent = (dataUrl) => {
//   return new Promise((resolve) => {
//     const img = new Image();
//     img.onload = () => {
//       // Scale down image to reasonable signature dimensions (max 600x250) to prevent oversized payloads & PDF errors
//       const MAX_WIDTH = 600;
//       const MAX_HEIGHT = 250;
//       let width = img.width;
//       let height = img.height;

//       if (width > MAX_WIDTH) {
//         height = Math.round((height * MAX_WIDTH) / width);
//         width = MAX_WIDTH;
//       }
//       if (height > MAX_HEIGHT) {
//         width = Math.round((width * MAX_HEIGHT) / height);
//         height = MAX_HEIGHT;
//       }

//       const canvas = document.createElement('canvas');
//       canvas.width = width;
//       canvas.height = height;
//       const ctx = canvas.getContext('2d');
//       ctx.drawImage(img, 0, 0, width, height);

//       try {
//         const imgData = ctx.getImageData(0, 0, width, height);
//         const data = imgData.data;
//         for (let i = 0; i < data.length; i += 4) {
//           const r = data[i];
//           const g = data[i + 1];
//           const b = data[i + 2];
//           // If pixel is white or near white (threshold 210 to catch lighter paper backgrounds)
//           if (r > 210 && g > 210 && b > 210) {
//             data[i + 3] = 0; // Transparent
//           }
//         }
//         ctx.putImageData(imgData, 0, 0);
//         resolve(canvas.toDataURL('image/png'));
//       } catch (e) {
//         try {
//           resolve(canvas.toDataURL('image/png'));
//         } catch (canvasErr) {
//           resolve(dataUrl);
//         }
//       }
//     };
//     img.onerror = () => resolve(dataUrl);
//     img.src = dataUrl;
//   });
// };

// const SignaturePad = ({ onSave, onChange, initialType = 'DRAW' }) => {
//   const canvasRef = useRef(null);
//   const [sigType, setSigType] = useState(initialType); // DRAW, TYPE, UPLOAD
//   const [typedName, setTypedName] = useState('');
//   const [isDrawing, setIsDrawing] = useState(false);
//   const [uploadedSig, setUploadedSig] = useState(null);

//   const clearCanvas = React.useCallback((notify = true) => {
//     if (!canvasRef.current) return;
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext('2d');
    
//     const style = getComputedStyle(document.documentElement);
//     const textPri = style.getPropertyValue('--text-primary').trim() || '#0f172a';

//     // Clear canvas transparently
//     ctx.clearRect(0, 0, canvas.width, canvas.height);
    
//     // Reset brush options
//     ctx.strokeStyle = textPri;
//     ctx.lineWidth = 2.5;

//     if (notify && onChange) {
//       onChange('', 'DRAW');
//     }
//   }, [onChange]);

//   // Drawing Canvas setup
//   useEffect(() => {
//     if (sigType === 'DRAW' && canvasRef.current) {
//       const canvas = canvasRef.current;
//       const ctx = canvas.getContext('2d');
//       const style = getComputedStyle(document.documentElement);
//       const textPri = style.getPropertyValue('--text-primary').trim() || '#0f172a';
//       ctx.strokeStyle = textPri;
//       ctx.lineWidth = 2.5;
//       ctx.lineCap = 'round';
//       ctx.lineJoin = 'round';
//       clearCanvas(false);
//     }
//   }, [sigType, clearCanvas]);

//   const startDrawing = (e) => {
//     if (!canvasRef.current) return;
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext('2d');
//     const style = getComputedStyle(document.documentElement);
//     const textPri = style.getPropertyValue('--text-primary').trim() || '#0f172a';
//     ctx.strokeStyle = textPri;
//     ctx.lineWidth = 2.5;
//     ctx.lineCap = 'round';
//     ctx.lineJoin = 'round';
    
//     const rect = canvas.getBoundingClientRect();
//     const x = (e.clientX || e.touches[0].clientX) - rect.left;
//     const y = (e.clientY || e.touches[0].clientY) - rect.top;
    
//     ctx.beginPath();
//     ctx.moveTo(x, y);
//     setIsDrawing(true);
//   };

//   const draw = (e) => {
//     if (!isDrawing || !canvasRef.current) return;
//     e.preventDefault();
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext('2d');
//     const rect = canvas.getBoundingClientRect();
//     const x = (e.clientX || (e.touches && e.touches[0].clientX)) - rect.left;
//     const y = (e.clientY || (e.touches && e.touches[0].clientY)) - rect.top;

//     ctx.lineTo(x, y);
//     ctx.stroke();
//   };

//   const stopDrawing = () => {
//     setIsDrawing(false);
//     if (canvasRef.current && onChange) {
//       const dataUrl = canvasRef.current.toDataURL('image/png');
//       onChange(dataUrl, 'DRAW');
//     }
//   };

//   const handleFileUpload = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = async (event) => {
//         const rawDataUrl = event.target.result;
//         // Make the uploaded image transparent if possible
//         const transparentDataUrl = await makeImageTransparent(rawDataUrl);
//         setUploadedSig(transparentDataUrl);
//         if (onChange) {
//           onChange(transparentDataUrl, 'UPLOAD');
//         }
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleSubmit = () => {
//     if (sigType === 'DRAW') {
//       if (canvasRef.current) {
//         const dataUrl = canvasRef.current.toDataURL('image/png');
//         onSave(dataUrl, 'DRAW');
//       }
//     } else if (sigType === 'TYPE') {
//       if (!typedName.trim()) {
//         alert('Please type a name to sign.');
//         return;
//       }
//       onSave(typedName, 'TYPE');
//     } else if (sigType === 'UPLOAD') {
//       if (!uploadedSig) {
//         alert('Please upload a signature image first.');
//         return;
//       }
//       onSave(uploadedSig, 'UPLOAD');
//     }
//   };

//   return (
//     <div className="card" style={{ maxWidth: '450px', margin: '0 auto' }}>
//       <div className="card-title">
//         <span>Apply Electronic Signature</span>
//       </div>
      
//       <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem' }}>
//         <button 
//           type="button"
//           className={`btn ${sigType === 'DRAW' ? 'btn-primary' : 'btn-secondary'}`}
//           onClick={() => setSigType('DRAW')}
//           style={{ flex: 1, fontSize: '0.8rem', padding: '0.5rem' }}
//         >
//           Draw
//         </button>
//         <button 
//           type="button"
//           className={`btn ${sigType === 'TYPE' ? 'btn-primary' : 'btn-secondary'}`}
//           onClick={() => setSigType('TYPE')}
//           style={{ flex: 1, fontSize: '0.8rem', padding: '0.5rem' }}
//         >
//           Type
//         </button>
//         <button 
//           type="button"
//           className={`btn ${sigType === 'UPLOAD' ? 'btn-primary' : 'btn-secondary'}`}
//           onClick={() => setSigType('UPLOAD')}
//           style={{ flex: 1, fontSize: '0.8rem', padding: '0.5rem' }}
//         >
//           Upload
//         </button>
//       </div>

//       <div style={{ marginBottom: '1.25rem' }}>
//         {sigType === 'DRAW' && (
//           <div>
//             <div style={{ position: 'relative', width: '100%', maxWidth: '400px' }}>
//               <canvas
//                 ref={canvasRef}
//                 width={400}
//                 height={150}
//                 style={{
//                   border: '1px solid var(--border-color)',
//                   borderRadius: 'var(--border-radius-sm)',
//                   backgroundColor: 'var(--bg-secondary)',
//                   cursor: 'crosshair',
//                   touchAction: 'none',
//                   width: '100%',
//                   maxWidth: '400px',
//                   display: 'block'
//                 }}
//                 onMouseDown={startDrawing}
//                 onMouseMove={draw}
//                 onMouseUp={stopDrawing}
//                 onMouseLeave={stopDrawing}
//                 onTouchStart={startDrawing}
//                 onTouchMove={draw}
//                 onTouchEnd={stopDrawing}
//               />
//               <div 
//                 style={{
//                   position: 'absolute',
//                   bottom: '40px',
//                   left: '20px',
//                   right: '20px',
//                   height: '1px',
//                   backgroundColor: 'var(--border-color)',
//                   pointerEvents: 'none'
//                 }} 
//               />
//             </div>
//             <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '0.5rem' }}>
//               <button type="button" className="btn btn-secondary" style={{ padding: '0.25rem 0.75rem', fontSize: '0.75rem' }} onClick={() => clearCanvas(true)}>
//                 Clear Board
//               </button>
//             </div>
//           </div>
//         )}

//         {sigType === 'TYPE' && (
//           <div>
//             <input
//               type="text"
//               className="form-control"
//               placeholder="Type your full legal name"
//               value={typedName}
//               onChange={(e) => {
//                 setTypedName(e.target.value);
//                 if (onChange) onChange(e.target.value, 'TYPE');
//               }}
//               style={{ marginBottom: '1rem' }}
//             />
//             {typedName && (
//               <div 
//                 style={{
//                   border: '1px solid var(--border-color)',
//                   borderRadius: 'var(--border-radius-sm)',
//                   padding: '1.25rem 0.75rem',
//                   backgroundColor: 'var(--bg-tertiary)',
//                   textAlign: 'center',
//                   fontSize: typedName.length > 25 ? '1.25rem' : (typedName.length > 15 ? '1.5rem' : '2rem'),
//                   fontFamily: '"Outfit", cursive, sans-serif',
//                   fontStyle: 'italic',
//                   color: 'var(--primary)',
//                   letterSpacing: '1px',
//                   userSelect: 'none',
//                   wordBreak: 'break-word',
//                   overflowWrap: 'break-word'
//                 }}
//               >
//                 {typedName}
//               </div>
//             )}
//           </div>
//         )}

//         {sigType === 'UPLOAD' && (
//           <div>
//             <input
//               type="file"
//               accept="image/*"
//               className="form-control"
//               onChange={handleFileUpload}
//               style={{ marginBottom: '1rem' }}
//             />
//             {uploadedSig && (
//               <div style={{ textAlign: 'center', border: '1px solid var(--border-color)', padding: '0.5rem', borderRadius: 'var(--border-radius-sm)' }}>
//                 <img src={uploadedSig} alt="Uploaded signature" style={{ maxHeight: '100px', maxWidth: '100%' }} />
//               </div>
//             )}
//           </div>
//         )}
//       </div>

//       <p style={{ fontSize: '0.75rem', color: 'var(--text-tertiary)', marginBottom: '1rem', textAlign: 'center' }}>
//         By clicking "Apply", I agree that this is a legally binding equivalent of my handwritten signature.
//       </p>

//       <button type="button" className="btn btn-primary" style={{ width: '100%' }} onClick={handleSubmit}>
//         Apply Signature
//       </button>
//     </div>
//   );
// };

// export default SignaturePad;






















// src/components/SignaturePad.jsx
import React, { useRef, useState, useEffect } from 'react';

// Helper to convert white/near-white pixels to transparent & scale uploaded images down
const makeImageTransparent = (dataUrl) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      // Scale down image to reasonable signature dimensions (max 600x250) to prevent oversized payloads & PDF errors
      const MAX_WIDTH = 600;
      const MAX_HEIGHT = 250;
      let width = img.width;
      let height = img.height;

      if (width > MAX_WIDTH) {
        height = Math.round((height * MAX_WIDTH) / width);
        width = MAX_WIDTH;
      }
      if (height > MAX_HEIGHT) {
        width = Math.round((width * MAX_HEIGHT) / height);
        height = MAX_HEIGHT;
      }

      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);

      try {
        const imgData = ctx.getImageData(0, 0, width, height);
        const data = imgData.data;
        for (let i = 0; i < data.length; i += 4) {
          const r = data[i];
          const g = data[i + 1];
          const b = data[i + 2];
          // If pixel is white or near white (threshold 210 to catch lighter paper backgrounds)
          if (r > 210 && g > 210 && b > 210) {
            data[i + 3] = 0; // Transparent
          }
        }
        ctx.putImageData(imgData, 0, 0);
        resolve(canvas.toDataURL('image/png'));
      } catch (e) {
        try {
          resolve(canvas.toDataURL('image/png'));
        } catch (canvasErr) {
          resolve(dataUrl);
        }
      }
    };
    img.onerror = () => resolve(dataUrl);
    img.src = dataUrl;
  });
};

const SignaturePad = ({ onSave, onChange, initialType = 'DRAW' }) => {
  const canvasRef = useRef(null);
  const [sigType, setSigType] = useState(initialType); // DRAW, TYPE, UPLOAD
  const [typedName, setTypedName] = useState('');
  const [isDrawing, setIsDrawing] = useState(false);
  const [uploadedSig, setUploadedSig] = useState(null);

  const clearCanvas = React.useCallback((notify = true) => {
    if (!canvasRef.current) return;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    
    const style = getComputedStyle(document.documentElement);
    const textPri = style.getPropertyValue('--text-primary').trim() || '#0f172a';

    // Clear canvas transparently
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    
    // Reset brush options
    ctx.strokeStyle = textPri;
    ctx.lineWidth = 2.5;

    if (notify && onChange) {
      onChange('', 'DRAW');
    }
  }, [onChange]);

  // Drawing Canvas setup
  useEffect(() => {
    if (sigType === 'DRAW' && canvasRef.current) {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext('2d');
      const style = getComputedStyle(document.documentElement);
      const textPri = style.getPropertyValue('--text-primary').trim() || '#0f172a';
      ctx.strokeStyle = textPri;
      ctx.lineWidth = 2.5;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      clearCanvas(false);
    }
  }, [sigType, clearCanvas]);

  const startDrawing = (e) => {
    if (!canvasRef.current) return;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const style = getComputedStyle(document.documentElement);
    const textPri = style.getPropertyValue('--text-primary').trim() || '#0f172a';
    ctx.strokeStyle = textPri;
    ctx.lineWidth = 2.5;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    
    const rect = canvas.getBoundingClientRect();
    const x = (e.clientX || e.touches[0].clientX) - rect.left;
    const y = (e.clientY || e.touches[0].clientY) - rect.top;
    
    ctx.beginPath();
    ctx.moveTo(x, y);
    setIsDrawing(true);
  };

  const draw = (e) => {
    if (!isDrawing || !canvasRef.current) return;
    e.preventDefault();
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const rect = canvas.getBoundingClientRect();
    const x = (e.clientX || (e.touches && e.touches[0].clientX)) - rect.left;
    const y = (e.clientY || (e.touches && e.touches[0].clientY)) - rect.top;

    ctx.lineTo(x, y);
    ctx.stroke();
  };

  const stopDrawing = () => {
    setIsDrawing(false);
    if (canvasRef.current && onChange) {
      const dataUrl = canvasRef.current.toDataURL('image/png');
      onChange(dataUrl, 'DRAW');
    }
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = async (event) => {
        const rawDataUrl = event.target.result;
        // Make the uploaded image transparent if possible
        const transparentDataUrl = await makeImageTransparent(rawDataUrl);
        setUploadedSig(transparentDataUrl);
        if (onChange) {
          onChange(transparentDataUrl, 'UPLOAD');
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = () => {
    if (sigType === 'DRAW') {
      if (canvasRef.current) {
        const dataUrl = canvasRef.current.toDataURL('image/png');
        onSave(dataUrl, 'DRAW');
      }
    } else if (sigType === 'TYPE') {
      if (!typedName.trim()) {
        alert('Please type a name to sign.');
        return;
      }
      onSave(typedName, 'TYPE');
    } else if (sigType === 'UPLOAD') {
      if (!uploadedSig) {
        alert('Please upload a signature image first.');
        return;
      }
      onSave(uploadedSig, 'UPLOAD');
    }
  };

  return (
    <div className="card" style={{ maxWidth: '450px', margin: '0 auto' }}>
      <div className="card-title">
        <span>Apply Electronic Signature</span>
      </div>
      
      <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem' }}>
        <button 
          type="button"
          className={`btn ${sigType === 'DRAW' ? 'btn-primary' : 'btn-secondary'}`}
          onClick={() => setSigType('DRAW')}
          style={{ flex: 1, fontSize: '0.8rem', padding: '0.5rem' }}
        >
          Draw
        </button>
        <button 
          type="button"
          className={`btn ${sigType === 'TYPE' ? 'btn-primary' : 'btn-secondary'}`}
          onClick={() => setSigType('TYPE')}
          style={{ flex: 1, fontSize: '0.8rem', padding: '0.5rem' }}
        >
          Type
        </button>
        <button 
          type="button"
          className={`btn ${sigType === 'UPLOAD' ? 'btn-primary' : 'btn-secondary'}`}
          onClick={() => setSigType('UPLOAD')}
          style={{ flex: 1, fontSize: '0.8rem', padding: '0.5rem' }}
        >
          Upload
        </button>
      </div>

      <div style={{ marginBottom: '1.25rem' }}>
        {sigType === 'DRAW' && (
          <div>
            <div style={{ position: 'relative', width: '100%', maxWidth: '400px' }}>
              <canvas
                ref={canvasRef}
                width={400}
                height={150}
                style={{
                  border: '1px solid var(--border-color)',
                  borderRadius: 'var(--border-radius-sm)',
                  backgroundColor: 'var(--bg-secondary)',
                  cursor: 'crosshair',
                  touchAction: 'none',
                  width: '100%',
                  maxWidth: '400px',
                  display: 'block'
                }}
                onMouseDown={startDrawing}
                onMouseMove={draw}
                onMouseUp={stopDrawing}
                onMouseLeave={stopDrawing}
                onTouchStart={startDrawing}
                onTouchMove={draw}
                onTouchEnd={stopDrawing}
              />
              <div 
                style={{
                  position: 'absolute',
                  bottom: '40px',
                  left: '20px',
                  right: '20px',
                  height: '1px',
                  backgroundColor: 'var(--border-color)',
                  pointerEvents: 'none'
                }} 
              />
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '0.5rem' }}>
              <button type="button" className="btn btn-secondary" style={{ padding: '0.25rem 0.75rem', fontSize: '0.75rem' }} onClick={() => clearCanvas(true)}>
                Clear Board
              </button>
            </div>
          </div>
        )}

        {sigType === 'TYPE' && (
          <div>
            <input
              type="text"
              className="form-control"
              placeholder="Type your full legal name"
              value={typedName}
              onChange={(e) => {
                setTypedName(e.target.value);
                if (onChange) onChange(e.target.value, 'TYPE');
              }}
              style={{ marginBottom: '1rem' }}
            />
            {typedName && (
              <div 
                style={{
                  border: '1px solid var(--border-color)',
                  borderRadius: 'var(--border-radius-sm)',
                  padding: '1.25rem 0.75rem',
                  backgroundColor: 'var(--bg-tertiary)',
                  textAlign: 'center',
                  fontSize: typedName.length > 35 ? '1.05rem' : (typedName.length > 25 ? '1.25rem' : (typedName.length > 15 ? '1.5rem' : '1.85rem')),
                  fontFamily: '"Outfit", cursive, sans-serif',
                  fontStyle: 'italic',
                  color: 'var(--primary)',
                  letterSpacing: '1px',
                  userSelect: 'none',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}
              >
                {typedName}
              </div>
            )}
          </div>
        )}

        {sigType === 'UPLOAD' && (
          <div>
            <input
              type="file"
              accept="image/*"
              className="form-control"
              onChange={handleFileUpload}
              style={{ marginBottom: '1rem' }}
            />
            {uploadedSig && (
              <div style={{ textAlign: 'center', border: '1px solid var(--border-color)', padding: '0.5rem', borderRadius: 'var(--border-radius-sm)' }}>
                <img src={uploadedSig} alt="Uploaded signature" style={{ maxHeight: '100px', maxWidth: '100%' }} />
              </div>
            )}
          </div>
        )}
      </div>

      <p style={{ fontSize: '0.75rem', color: 'var(--text-tertiary)', marginBottom: '1rem', textAlign: 'center' }}>
        By clicking "Apply", I agree that this is a legally binding equivalent of my handwritten signature.
      </p>

      <button type="button" className="btn btn-primary" style={{ width: '100%' }} onClick={handleSubmit}>
        Apply Signature
      </button>
    </div>
  );
};

export default SignaturePad;
